import { Component, h, tag } from "omi";
import classNames from "classnames";

import { tailwind } from "@/tailwind";

type Props = {
  activeTypeFilter: string;
  handleTypeFilterChange: (type: string) => void;
};

@tag("nw-directory-content-type-filter")
export class ContentTypeFilter extends Component<Props> {
  static css = [tailwind];
  private FILTER_CHIPS = ["All", "Roadmaps", "Specialty", "Tools"];

  render({ activeTypeFilter, handleTypeFilterChange }: Props) {
    return (
      <div className="flex space-x-1 overflow-x-auto py-3 px-1 scrollbar-hide" style={{ letterSpacing: "-0.4px" }}>
        {this.FILTER_CHIPS.map(type => (
          <button
            key={type}
            className={classNames(
              "flex items-center px-3 py-2 rounded-md text-sm font-normal transition-all duration-200 whitespace-nowrap",
              type === activeTypeFilter ? "bg-[#f1f0ef] text-primary" : "text-secondary hover:bg-[#f0eeed]",
            )}
            aria-pressed={type === activeTypeFilter}
            onClick={() => handleTypeFilterChange(type)}
          >
            <span className={type === activeTypeFilter ? "text-primary" : "text-secondary"}>{type}</span>
          </button>
        ))}
      </div>
    );
  }
}
